import styles from '@/assets/styles/pages/competition/competition.module.scss';
import { MimaText, FashButton, MimaButton } from '@/components';
import { SiGnuprivacyguard } from 'react-icons/si';
import constant from '@/utils/constant';
import Link from 'next/link';
import { useSwitchNav } from '@/components/PageLayout/_PageLayoutComponents/SwitchNav';
import { amountFormatter } from '@/utils/utils';

interface CompetitionsProps {
  competitionList: any;
}

const Hero: React.FC<CompetitionsProps> = ({ competitionList }) => {
  const { switchToRegister, goToAllContestants } = useSwitchNav();
  const currentCompetition = competitionList?.filter((item: any) => item?.status === 'ACTIVE').map((competition: any) => competition);

  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.text}>
          <MimaText variant="h1" color="var(--color-white)">
            {`The ${currentCompetition?.[0]?.name ?? ''} Competition.`}
          </MimaText>
          <MimaText variant="subtitleBold" color="var(--color-white)">
            Join the competition to win Prizes worth up to{' '}
            <span>{`${amountFormatter(currentCompetition?.[0]?.currencyCode).format(currentCompetition?.[0]?.winningAmount ?? '')}.`} </span>{' '}
            {currentCompetition?.[0]?.summary}
          </MimaText>
        </div>
        <div className={styles.buttonSet}>
          <Link href={`${constant.Routes.Competition}#learnMore`}>
            <FashButton title="Learn More" icon color="var(--color-primary-2)" />
          </Link>

          {currentCompetition?.[0]?.stage === 'REG' && (
            <MimaButton
              title="Register"
              icon={<SiGnuprivacyguard />}
              onClick={switchToRegister}
              variant="outlined"
              buttonColor="var(--color-white)"
              width={18}
              height={6}
            />
          )}

          {currentCompetition?.[0]?.stage ? (
            <FashButton
              title="View Contestants"
              onClick={() => {
                goToAllContestants(currentCompetition?.[0]?.stage, currentCompetition?.[0]?._id);
              }}
              color="var(--color-primary-2)"
              icon
            />
          ) : (
            ''
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
